import { render, staticRenderFns } from "./cartDreieckGS.vue?vue&type=template&id=48d21d46&"
import script from "./cartDreieckGS.vue?vue&type=script&lang=js&"
export * from "./cartDreieckGS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports